__turbopack_context__.v({
  "newsletter-subscribe": "LoGZlW_newsletter-subscribe",
});
